import { Injectable } from '@angular/core';
import { StorageKeys } from '@enums/storage-keys';
import { AnalyteCareLoadCartResponse } from '@models/analyte-care-load-cart-response';
import { OrderService } from '@services/order.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyteHealthOrderService extends OrderService {
  /**
   * Gets the account token to send with the load cart request so the API can resolve the business account pricing.
   */
  public override get authToken(): string | null {
    return this.storage.authToken;
  }

  /**
   * Update discounts in local storage.
   *
   * @param {AnalyteCareLoadCartResponse} response the load-cart response from AnalyteCare
   */
  protected override saveCartResponse(response: AnalyteCareLoadCartResponse): void {
    super.saveCartResponse(response);

    if (!this.storage.baOrder?.isActive) {
      return;
    }

    this.storage.remove(StorageKeys.Coupon);
    this.storage.remove(StorageKeys.Discount);

    if (this.storage.baOrder?.isStateComplianceFeeWaived) {
      this.storage.remove(StorageKeys.Fee);
    }
  }
}
